// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VModal from 'vue-js-modal'
import axios from 'axios'
// import Loading from 'vue-loading-overlay'
// import 'vue-loading-overlay/dist/vue-loading.css'

Vue.config.productionTip = false

Vue.use(VModal, { dynamic: true })

// Response Interceptor
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.interceptors.response.use(
  function (response) { return response },
  function (error) {
    // handle error
    if (error.response) {
      console.log(error.response)
      if (error.response.status === 408) {
        location.href = '/'
        alert('요청시간이 만료되었습니다.')
      }
      if (error.response.status === 400) {
        location.href = '/'
        alert('잘못된 요청입니다.')
      }
    }
    return Promise.reject(error)
  }
)

// Vue.use(Loading)
/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

window.app = vm



// WEBPACK FOOTER //
// ./src/main.js